import { type ClusterWithCloudConnect } from "@doitintl/cmp-models";
import { type WithModel } from "@doitintl/models-any";

export enum ClusterComputedStatus {
  CONNECTION_ISSUE = "01-Connection issue",
  UNHEALTHY = "02-Unhealthy",
  NOT_CONFIGURED = "03-Not configured",
  HEALTHY = "04-Healthy",
  PARTIAL = "05-Partial",
  DELETED = "06-Deleted",
  PRIVATE = "07-Private",
  UNKNOWN = "08-Unknown",
}

export enum ClusterAgentStatus {
  NEVER_TRANSMITTED = "01-Never transmitted",
  WAITING_FOR_DATA = "02-Waiting for data",
  TRANSMITTING = "03-Transmitting",
  STOPPED_TRANSMITTING = "04-Stopped transmitting",
}

export interface ClusterTableItem extends WithModel<ClusterWithCloudConnect> {
  enabledFeatures?: string;
  computedStatus: ClusterComputedStatus;
  agentStatus: ClusterAgentStatus;
}
